export const dateTimeFormats = {
	short: {
		month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	medium: {
		year: 'numeric', month: 'long', day: 'numeric'
	},
	long: {
		year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	full: {
		year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
	}
};
export const messages = {
    "login.form.title": "Iniciar sessão",
    "login.form.hint.user": "Iniciar sessão",
    "login.form.hint.password": "Palavra-passe",
    "login.form.checkbox.remember-me": "Memorizar-me",
    "login.form.button.sign-in": "Iniciar sessão",
    "login.form.message.invalid-user-credentials": "O início de sessão ou palavra-passe está incorreto",
    "login.form.message.account-temporarily-locked": "A sua conta está temporariamente bloqueada. Regresse dentro de 5 minutos",
    "login.form.message.user-required": "Introduza um início de sessão",
    "login.form.message.password-required": "Introduza uma palavra-passe",
    "login.form.button.forgot-password": "Esqueceu-se da palavra-passe?",
    "error.mfa-required.title": "Configurar 2FA",
    "error.mfa-required.message1": "A autenticação de dois fatores (2FA) é necessária para proteger a sua conta.",
    "error.mfa-required.message2": "Será redirecionado para as definições da sua conta no Painel de Controlo Online. Ative a 2FA, siga as instruções de configuração e depois volte aqui.",
    "error.mfa-required.learnMore": "Saiba mais sobre 2FA",
    "error.mfa-required.continue": "Continuar",
    "error.root-admin-login.title": "Erro 403 – operação proibida",
    "error.root-admin-login.message": "Tem sessão iniciada como Administrador só de leitura. Para aceder à consola do Web Recovery, inicie sessão como utilizador ou administrador de um inquilino de cliente",
    "error.server-busy.message": "O servidor está ocupado. Tente novamente mais tarde.",
    "error.network-connection.title": "Erro na ligação de rede",
    "error.network-connection.message": "Verifique a ligação à Internet e tente novamente.",
    "error.internal-server-error.title": "Erro de servidor interno",
    "error.internal-server-error.message": "Para resolver o erro, contacte o suporte e indique os detalhes do erro:",
    "error.internal-server-error.copy.button": "Copiar"
};
